import { render, staticRenderFns } from "./FaqItems.vue?vue&type=template&id=1d0bd6ea&scoped=true"
import script from "./FaqItems.vue?vue&type=script&lang=js"
export * from "./FaqItems.vue?vue&type=script&lang=js"
import style0 from "./FaqItems.vue?vue&type=style&index=0&id=1d0bd6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bd6ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
